import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
    createTextVNode as _$ct,
} from 'intact';
import {Sender, Select, Option, ButtonGroup, Button, Icon} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['configure'] = function($super) {
                        return (
                            _$ce(2, 'div', [
                                _$cc(ButtonGroup, {
                                    'checkType': 'checkbox',
                                    'separate': true,
                                    'children': [
                                        _$cc(Button, {
                                            'value': 'think',
                                            'size': 'small',
                                            'children': [
                                                _$cc(Icon, {
                                                    'className': 'k-icon-think',
                                                    'color': this.getToolIconColor('think')
                                                }),
                                                _$ct('\n                    深度\n                ')
                                            ]
                                        }),
                                        _$cc(Button, {
                                            'value': 'internet',
                                            'size': 'small',
                                            'children': [
                                                _$cc(Icon, {
                                                    'className': 'k-icon-internet',
                                                    'color': this.getToolIconColor('internet')
                                                }),
                                                _$ct('\n                    联网\n                ')
                                            ]
                                        })
                                    ],
                                    'ev-$model:value': function($v) {
                                        $this.set('tools', $v);
                                    },
                                    'value': $this.get('tools')
                                }),
                                _$cc(Select, {
                                    'size': 'small',
                                    'width': 140,
                                    'children': [
                                        _$cc(Option, {
                                            'value': 'gpt-4o',
                                            'children': 'GPT-4o'
                                        }),
                                        _$cc(Option, {
                                            'value': 'claude-3.5',
                                            'children': 'Claude 3.5'
                                        }),
                                        _$cc(Option, {
                                            'value': 'qwen-72b',
                                            'children': 'Qwen 72B'
                                        })
                                    ],
                                    'ev-$model:value': function($v) {
                                        $this.set('model', $v);
                                    },
                                    'value': $this.get('model')
                                })
                            ], 4, 'sender-demo-configure')
                        );
                    }),
                    (__$blocks['configure'] = function($super, data) {
                        var block = $blocks['configure'];
                        var callBlock = function() {
                            return _$blocks['configure'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em),
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};